module.exports = __webpack_public_path__ + "static/media/identification_card_front.0c6063ad.svg";